export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mobile_web.4b4903f.svg";